import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';

import { CheckinPopoverComponent } from './checkin-popover';

@NgModule({
  declarations: [
    CheckinPopoverComponent
  ],
  imports: [
    IonicPageModule.forChild(CheckinPopoverComponent)
  ],
  exports: [
    CheckinPopoverComponent
  ]
})
export class CheckinPopoverModule {}



// WEBPACK FOOTER //
// ./src/components/checkin-popover/checkin-popover.module.ts